import { createAsyncThunk } from "@reduxjs/toolkit";
import { updateSubstations, createSubstations, substationModule, getSubstations } from "@/api/modules/subtation";


export const updateSubstationsAction = createAsyncThunk(
    "updateSubstations",
    async ({ substationId, data }: any) => {
        // getUserChannels函数是一个axios的请求
        const result = await updateSubstations(substationId, data);
        if (result.data) return result.data;
    }
)

export const createSubstationsAction = createAsyncThunk(
    "createSubstations",
    async (data: any) => {
        // getUserChannels函数是一个axios的请求
        const result = await createSubstations(data);
        if (result.data) return result.data;
    }
)


export const substationModuleAction = createAsyncThunk(
    "substationModule",
    async (substationId: any) => {
        // getUserChannels函数是一个axios的请求
        const result = await substationModule(substationId);
        if (result.data) return result.data;
    }
)

export const getSubstationsAction = createAsyncThunk(
    "getSubstations",
    async (data: any) => {
        // getUserChannels函数是一个axios的请求
        const result = await getSubstations(data);
        if (result.data) return result.data;
    }
)